import { Helmet } from 'react-helmet';
import {
  AppBar,
  Box,
  Container,
  Grid,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import ProductProfileDetails from 'src/components/product/ProductProfileDetails';
import HistoryListResults from 'src/components/product/HistoryListResults';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ProductContext } from 'src/context/ProductContext';
import { ClientContext } from 'src/context/ClientContext';
import { OrderContext } from 'src/context/OrderContext';

function TabPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const tab = {
  color: '#FFF'
};

const tabSelected = {
  color: '#FFF',
  borderBottom: '5px solid red'
};

const ProductForm = () => {
  const { id, clientId } = useParams();
  const {
    product,
    setProduct,
    getProduct,
    saveProduct,
    updateProduct,
  } = useContext(ProductContext);

  const { orders, getOrdersByProduct } = useContext(OrderContext);

  const {
    clientsAll,
    getAllClients,
    searchClients
  } = useContext(ClientContext);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(async () => {
    await getAllClients();
    if (id) {
      await getProduct(id);
      await getOrdersByProduct(id);
    } else {
      setProduct(null);
    }
  }, []);

  useEffect(() => {
    if (id) {
      if (product
          && clientsAll.data
          && clientsAll.data.length > 0
      ) {
        setLoading(false);
      }
    }

    if (!id) {
      if (clientsAll.data
        && clientsAll.data.length > 0
      ) {
        setProduct(null);
        setLoading(false);
      }
    }
  }, [product, clientsAll]);

  return (
    <>
      <Helmet>
        <title>
          {`Product | ${process.env.REACT_APP_NAME}`}
        </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth="lg">
          {loading === false
            ? (
              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  xs={12}
                >
                  <AppBar position="static">
                    <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                      <Tab style={value === 0 ? tabSelected : tab} label="Dados" {...a11yProps(0)} />
                      {product
                        ? (
                          <Tab style={value === 1 ? tabSelected : tab} label="Histórico de Serviços" {...a11yProps(1)} />
                        )
                        : <></> }
                    </Tabs>
                  </AppBar>
                  <TabPanel value={value} index={0} style={{ backgroundColor: '#fff' }}>
                    <ProductProfileDetails
                      product={product}
                      clientId={clientId}
                      saveform={saveProduct}
                      updateform={updateProduct}
                      clients={clientsAll}
                      search={searchClients}
                    />
                  </TabPanel>
                  {product
                    ? (
                      <TabPanel value={value} index={1} style={{ backgroundColor: '#fff' }}>
                        <HistoryListResults orders={orders} />
                      </TabPanel>
                    )
                    : <></> }
                </Grid>
              </Grid>
            )
            : <></> }
        </Container>
      </Box>
    </>
  );
};
export default ProductForm;
